import React from 'react'
import CatalogPage from '../components/catalogue/productCatalogue'

const OurProducts = () => {
    return (
        <React.Fragment>
         <CatalogPage />
        </React.Fragment>
    )
}

export default OurProducts